module.exports = __webpack_public_path__ + "img/naturalwayu.a2ecb1ee.png";